import { useToast } from 'primevue/usetoast'
export default {
   install: (app) => {
      app.config.globalProperties.$errorHandler = (err, instance, info) => {
         const toast = useToast()
         if (err.response && err.response.config) {
            const { mensagens } = err.response.data
            const mensagem = mensagens[0].descricao || 'Ocorreu um erro ao processar a solicitação'

            toast.add({
               severity: 'error',
               summary: 'Falha',
               detail: mensagem,
               life: 4000
            })
            console.log(`Erro (${err.response.status}): ${mensagem}`, 'Instância:', instance)
         } else {
            console.log('Erro:', err, 'Instância:', instance)
         }
      }
   }
}
